'use client';

export const TestErrorTrigger = ({ errorId }: { errorId: number | string }) => {
  const triggerError = (() => {
    if (typeof window === 'undefined') return false;
    const errorIdQuery = new URLSearchParams(window.location.search).get(
      'error_id'
    );
    return errorIdQuery === errorId.toString();
  })();

  if (triggerError) {
    throw new Error(`Test error triggered with errorId: ${errorId}`);
  }

  return null;
};
